import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  OnInit,
  ChangeDetectionStrategy,
  OnChanges
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import { Utils } from '../../services';

@Component({
  selector: 'cs-player',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="cs-player-wrapper">
      <audio 
        preload="false"
        #player
        [id]="id">
        <source 
          [src]="inputs.src">
      </audio>

      <i
        class="toggle-play"
        [ngClass]="{
          'ion-play': !(playInProgress$ | async),
          'ion-stop': (playInProgress$ | async)
        }"
        (click)="toggle()">
      </i>
    </div>
  `
})

export class CsPlayerComponent implements OnInit, OnChanges {
  @Input() inputs: any = {};
  @Output() play = new EventEmitter<Object>();
  @Output() stop = new EventEmitter<Object>();
  @ViewChild('player') player: ElementRef;

  playInProgress$: Subject<boolean> = new Subject<boolean>();

  id;
  src;
  interval;

  constructor(
    private utils: Utils
  ) {
    this.id = this.utils.generateShortUID();
    this.playInProgress$.next(false);
  }

  ngOnInit() {
    this.src = this.inputs.src;
  }

  toggle() {
    if (this.player.nativeElement.paused) {
      this.play.emit({
        audio: this.player.nativeElement,
        id: this.id
      });

      this.playInProgress$.next(true);
      this.interval = setInterval(() => {
        if (this.player.nativeElement.paused) {
          clearInterval(this.interval);
          this.playInProgress$.next(false);
        }
      }, 500);
    } else {
      this.stop.emit();
      this.playInProgress$.next(false);
    }
  }

  // TODO: add onDestroy with clearInterval

  ngOnChanges() {
    if (!this.src) {
      return;
    }

    if (this.src !== this.inputs.src) {
      this.src = this.inputs.src;
      this.player.nativeElement.src = this.inputs.src;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-player/cs-player.component.ts